var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-bubble flex flex-align-center"},[_c('p',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }